import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InfoTextIconComponent } from './info-text-icon.component';

@Component({
  selector: 'mwe-info-text',
  templateUrl: './info-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InfoTextIconComponent],
})
export class InfoTextComponent {
  infoTextCode = input<string>();
  infoTextTitle = input<string>();
  infoTextDescription = input<string>();
  infoTextLink = input<{ name: string; target: string }>();
  colorClass = input('');
  customUrlOverride = input<string>();
  dataTest = input<string>();
  translateParams = input<any>();
}
